export const deck = {
    "cards": [
        {
            "code": "9H",
            "image": "https://deckofcardsapi.com/static/img/9H.png",
            "value": "9",
            "suit": "HEARTS"
        },
        {
            "code": "QH",
            "image": "https://deckofcardsapi.com/static/img/QH.png",

            "value": "10",
            "suit": "HEARTS"
        },
        {
            "code": "AH",
            "image": "https://deckofcardsapi.com/static/img/AH.png",

            "value": "1",
            "suit": "HEARTS"
        },
        {
            "code": "2S",
            "image": "https://deckofcardsapi.com/static/img/2S.png",

            "value": "2",
            "suit": "SPADES"
        },
        {
            "code": "JD",
            "image": "https://deckofcardsapi.com/static/img/JD.png",

            "value": "10",
            "suit": "DIAMONDS"
        },
        {
            "code": "9C",
            "image": "https://deckofcardsapi.com/static/img/9C.png",

            "value": "9",
            "suit": "CLUBS"
        },
        {
            "code": "9D",
            "image": "https://deckofcardsapi.com/static/img/9D.png",

            "value": "9",
            "suit": "DIAMONDS"
        },
        {
            "code": "8C",
            "image": "https://deckofcardsapi.com/static/img/8C.png",

            "value": "8",
            "suit": "CLUBS"
        },
        {
            "code": "KS",
            "image": "https://deckofcardsapi.com/static/img/KS.png",

            "value": "10",
            "suit": "SPADES"
        },
        {
            "code": "QC",
            "image": "https://deckofcardsapi.com/static/img/QC.png",

            "value": "10",
            "suit": "CLUBS"
        },
        {
            "code": "0C",
            "image": "https://deckofcardsapi.com/static/img/0C.png",

            "value": "10",
            "suit": "CLUBS"
        },
        {
            "code": "8S",
            "image": "https://deckofcardsapi.com/static/img/8S.png",

            "value": "8",
            "suit": "SPADES"
        },
        {
            "code": "6C",
            "image": "https://deckofcardsapi.com/static/img/6C.png",

            "value": "6",
            "suit": "CLUBS"
        },
        {
            "code": "0D",
            "image": "https://deckofcardsapi.com/static/img/0D.png",

            "value": "10",
            "suit": "DIAMONDS"
        },
        {
            "code": "4S",
            "image": "https://deckofcardsapi.com/static/img/4S.png",

            "value": "4",
            "suit": "SPADES"
        },
        {
            "code": "KD",
            "image": "https://deckofcardsapi.com/static/img/KD.png",

            "value": "10",
            "suit": "DIAMONDS"
        },
        {
            "code": "5C",
            "image": "https://deckofcardsapi.com/static/img/5C.png",

            "value": "5",
            "suit": "CLUBS"
        },
        {
            "code": "7C",
            "image": "https://deckofcardsapi.com/static/img/7C.png",

            "value": "7",
            "suit": "CLUBS"
        },
        {
            "code": "8H",
            "image": "https://deckofcardsapi.com/static/img/8H.png",

            "value": "8",
            "suit": "HEARTS"
        },
        {
            "code": "2H",
            "image": "https://deckofcardsapi.com/static/img/2H.png",

            "value": "2",
            "suit": "HEARTS"
        },
        {
            "code": "6D",
            "image": "https://deckofcardsapi.com/static/img/6D.png",

            "value": "6",
            "suit": "DIAMONDS"
        },
        {
            "code": "JS",
            "image": "https://deckofcardsapi.com/static/img/JS.png",

            "value": "10",
            "suit": "SPADES"
        },
        {
            "code": "AC",
            "image": "https://deckofcardsapi.com/static/img/AC.png",

            "value": "1",
            "suit": "CLUBS"
        },
        {
            "code": "0S",
            "image": "https://deckofcardsapi.com/static/img/0S.png",

            "value": "10",
            "suit": "SPADES"
        },
        {
            "code": "0H",
            "image": "https://deckofcardsapi.com/static/img/0H.png",

            "value": "10",
            "suit": "HEARTS"
        },
        {
            "code": "6H",
            "image": "https://deckofcardsapi.com/static/img/6H.png",

            "value": "6",
            "suit": "HEARTS"
        },
        {
            "code": "7D",
            "image": "https://deckofcardsapi.com/static/img/7D.png",

            "value": "7",
            "suit": "DIAMONDS"
        },
        {
            "code": "5D",
            "image": "https://deckofcardsapi.com/static/img/5D.png",

            "value": "5",
            "suit": "DIAMONDS"
        },
        {
            "code": "AD",
            "image": "https://deckofcardsapi.com/static/img/aceDiamonds.png",

            "value": "1",
            "suit": "DIAMONDS"
        },
        {
            "code": "JH",
            "image": "https://deckofcardsapi.com/static/img/JH.png",

            "value": "10",
            "suit": "HEARTS"
        },
        {
            "code": "JC",
            "image": "https://deckofcardsapi.com/static/img/JC.png",

            "value": "10",
            "suit": "CLUBS"
        },
        {
            "code": "7S",
            "image": "https://deckofcardsapi.com/static/img/7S.png",

            "value": "7",
            "suit": "SPADES"
        },
        {
            "code": "QS",
            "image": "https://deckofcardsapi.com/static/img/QS.png",

            "value": "10",
            "suit": "SPADES"
        },
        {
            "code": "3S",
            "image": "https://deckofcardsapi.com/static/img/3S.png",

            "value": "3",
            "suit": "SPADES"
        },
        {
            "code": "4H",
            "image": "https://deckofcardsapi.com/static/img/4H.png",

            "value": "4",
            "suit": "HEARTS"
        },
        {
            "code": "QD",
            "image": "https://deckofcardsapi.com/static/img/QD.png",

            "value": "10",
            "suit": "DIAMONDS"
        },
        {
            "code": "4D",
            "image": "https://deckofcardsapi.com/static/img/4D.png",

            "value": "4",
            "suit": "DIAMONDS"
        },
        {
            "code": "5H",
            "image": "https://deckofcardsapi.com/static/img/5H.png",

            "value": "5",
            "suit": "HEARTS"
        },
        {
            "code": "KH",
            "image": "https://deckofcardsapi.com/static/img/KH.png",

            "value": "10",
            "suit": "HEARTS"
        },
        {
            "code": "9S",
            "image": "https://deckofcardsapi.com/static/img/9S.png",

            "value": "9",
            "suit": "SPADES"
        },
        {
            "code": "2D",
            "image": "https://deckofcardsapi.com/static/img/2D.png",

            "value": "2",
            "suit": "DIAMONDS"
        },
        {
            "code": "3C",
            "image": "https://deckofcardsapi.com/static/img/3C.png",

            "value": "3",
            "suit": "CLUBS"
        },
        {
            "code": "5S",
            "image": "https://deckofcardsapi.com/static/img/5S.png",

            "value": "5",
            "suit": "SPADES"
        },
        {
            "code": "8D",
            "image": "https://deckofcardsapi.com/static/img/8D.png",

            "value": "8",
            "suit": "DIAMONDS"
        },
        {
            "code": "2C",
            "image": "https://deckofcardsapi.com/static/img/2C.png",

            "value": "2",
            "suit": "CLUBS"
        },
        {
            "code": "4C",
            "image": "https://deckofcardsapi.com/static/img/4C.png",

            "value": "4",
            "suit": "CLUBS"
        },
        {
            "code": "3D",
            "image": "https://deckofcardsapi.com/static/img/3D.png",

            "value": "3",
            "suit": "DIAMONDS"
        },
        {
            "code": "3H",
            "image": "https://deckofcardsapi.com/static/img/3H.png",

            "value": "3",
            "suit": "HEARTS"
        },
        {
            "code": "AS",
            "image": "https://deckofcardsapi.com/static/img/AS.png",

            "value": "1",
            "suit": "SPADES"
        },
        {
            "code": "6S",
            "image": "https://deckofcardsapi.com/static/img/6S.png",

            "value": "6",
            "suit": "SPADES"
        },
        {
            "code": "7H",
            "image": "https://deckofcardsapi.com/static/img/7H.png",

            "value": "7",
            "suit": "HEARTS"
        },
        {
            "code": "KC",
            "image": "https://deckofcardsapi.com/static/img/KC.png",

            "value": "10",
            "suit": "CLUBS"
        }
    ],
}